<div class="add-load-dialog col">
  <div class="ald-header row">
    <p class="ald-title">Add Load</p>
    <button mat-icon-button class="close-btn" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="ald-body col" [formGroup]="filtersForm">
    <div class="ald-toolbar row">
      <mat-checkbox class="row-checkbox select-all"
                    [checked]="isAllVisibleSelected()"
                    [indeterminate]="isAllVisiblePartiallySelected()"
                    [disabled]="selectAllLoading"
                    (change)="toggleSelectAllVisible($event.checked)">
        <span class="select-all-label">Select All</span>
        <mat-progress-spinner *ngIf="selectAllLoading"
                              class="select-all-spinner"
                              diameter="14"
                              mode="indeterminate"></mat-progress-spinner>
      </mat-checkbox>

      <div class="toolbar-right row">
        <mat-form-field appearance="outline" class="search-field">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="text" placeholder="Search Loads" formControlName="searchKey">
        </mat-form-field>

        <mat-form-field appearance="outline" class="date-field">
          <mat-label>From</mat-label>
          <input matInput [matDatepicker]="fromPicker" placeholder="DD/MM/YYYY" formControlName="fromDate">
          <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="date-field">
          <mat-label>To</mat-label>
          <input matInput [matDatepicker]="toPicker" placeholder="DD/MM/YYYY" formControlName="toDate">
          <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="ald-list col">
      <ng-container *ngIf="jobsPage?.content?.length; else emptyJobs">
        <mat-expansion-panel class="job-card"
                             *ngFor="let job of jobsPage.content; trackBy: trackByJobRefId"
                             [expanded]="isJobExpanded(job.jobRefId)"
                             (opened)="toggleJob(job.jobRefId)"
                             (closed)="expandedJobIds.delete(job.jobRefId)">
          <mat-expansion-panel-header class="job-card-header">
            <mat-panel-title class="job-title row">
              <div class="row-checkbox-wrapper" (click)="$event.stopPropagation()">
                <mat-checkbox class="row-checkbox"
                              [checked]="isJobSelected(job.jobRefId)"
                              [indeterminate]="isJobPartiallySelected(job.jobRefId)"
                              (change)="toggleJobSelection(job.jobRefId, $event.checked)">
                </mat-checkbox>
              </div>
              <div class="job-title-text col">
                <p class="muted-label">Job File Name</p>
                <p class="bold">{{ job.jobTitle }}</p>
              </div>
            </mat-panel-title>
            <mat-panel-description class="job-desc">
              <div class="count-block col">
                <p class="bold">{{ job.pendingLoads }}</p>
                <p class="muted-label">Pending</p>
              </div>
              <div class="count-block col">
                <p class="bold">{{ job.completedLoads }}</p>
                <p class="muted-label">Completed</p>
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="loads-list col">
            <ng-container *ngIf="loadsByJob[job.jobRefId]?.content?.length; else noLoads">
              <div class="load-card col"
                   *ngFor="let load of loadsByJob[job.jobRefId].content; trackBy: trackByJpmId"
                   [class.expanded]="isLoadExpanded(load.jpmId)"
                   [class.disabled]="!isLoadSelectable(load)">
                <div class="load-card-top row">
                  <div class="row-checkbox-wrapper" (click)="$event.stopPropagation()">
                    <mat-checkbox class="row-checkbox"
                                  [checked]="isLoadSelected(load.jpmId)"
                                  [disabled]="!isLoadSelectable(load)"
                                  (change)="toggleLoad(load, $event.checked)">
                    </mat-checkbox>
                  </div>
                  <div class="load-meta col"
                       (click)="toggleLoadExpand(load.jpmId)">
                    <p class="muted-label">Load Id</p>
                    <p class="bold">{{ load.loadNumber || load.loadId }}</p>
                  </div>
                  <span class="already-added-chip" *ngIf="isLoadAlreadyInInvoice(load)">Already in invoice</span>
                  <button mat-icon-button class="chevron-btn"
                          (click)="toggleLoadExpand(load.jpmId)">
                    <mat-icon>{{ isLoadExpanded(load.jpmId) ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>

                <div class="locations-strip row"
                     *ngIf="load.locations?.length">
                  <ng-container *ngFor="let loc of getBreadcrumb(load.locations); let last = last">
                    <span class="location-chip">{{ loc }}</span>
                    <mat-icon class="loc-arrow" *ngIf="!last">double_arrow</mat-icon>
                  </ng-container>
                </div>

                <ng-container *ngIf="isLoadExpanded(load.jpmId)">
                  <div class="breakdown col">
                    <p class="section-heading">Fee Breakdown (Fees, Discounts, Taxes)</p>

                    <div class="break-row row">
                      <span class="break-desc">
                        Transportation Fee
                        <span class="break-sub" *ngIf="isWeightBasedLoad(load)">{{ weightFreightSubLine(load) }}</span>
                      </span>
                      <span class="break-amount">{{ applyCurrency(load.loadCost) }}</span>
                    </div>

                    <div class="break-section-head row">
                      <span class="bold">Fees</span>
                      <button mat-button class="link-btn" (click)="addExpense(load)">+ Add Item</button>
                    </div>
                    <div class="break-row row" *ngFor="let exp of load.expenses">
                      <span class="break-desc">{{ exp.costDescription }}</span>
                      <span class="break-amount">+ {{ applyCurrency(exp.amount) }}</span>
                      <div class="row-actions">
                        <mat-icon class="row-action" (click)="addExpense(load, exp)">edit</mat-icon>
                        <mat-icon class="row-action danger" (click)="removeExpense(load, exp.id)">close</mat-icon>
                      </div>
                    </div>
                    <div class="break-row row" *ngFor="let item of load.addedOtherCost">
                      <span class="break-desc">{{ item.costDescription }}</span>
                      <span class="break-amount" *ngIf="item.paymentType === paymentType.PERCENTAGE">{{ item.amount }} %</span>
                      <span class="break-amount" *ngIf="item.paymentType !== paymentType.PERCENTAGE">+ {{ applyCurrency(item.amount) }}</span>
                      <div class="row-actions">
                        <mat-icon class="row-action" (click)="addAddedItem(load, item)">edit</mat-icon>
                        <mat-icon class="row-action danger" (click)="removeAddedItem(load, item.id)">close</mat-icon>
                      </div>
                    </div>

                    <div class="break-section-head row">
                      <span class="bold">Discounts</span>
                      <button mat-button class="link-btn"
                              *ngIf="!load.addedDiscount"
                              (click)="addDiscount(load)">+ Add Item</button>
                    </div>
                    <div class="break-row row" *ngIf="load.addedDiscount as discount">
                      <span class="break-desc">{{ discount.costDescription }}</span>
                      <span class="break-amount" *ngIf="discount.paymentType === paymentType.PERCENTAGE">{{ discount.amount }} %</span>
                      <span class="break-amount" *ngIf="discount.paymentType !== paymentType.PERCENTAGE">- {{ applyCurrency(discount.amount) }}</span>
                      <div class="row-actions">
                        <mat-icon class="row-action" (click)="addDiscount(load)">edit</mat-icon>
                        <mat-icon class="row-action danger" (click)="removeDiscount(load)">close</mat-icon>
                      </div>
                    </div>

                    <div class="break-row row total-row">
                      <span class="break-desc bold">Load Total</span>
                      <span class="break-amount bold">{{ applyCurrency(loadTotal(load)) }}</span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #noLoads>
              <p class="empty">No completed loads available</p>
            </ng-template>
          </div>
        </mat-expansion-panel>
      </ng-container>
      <ng-template #emptyJobs>
        <p class="empty">No jobs available for this customer.</p>
      </ng-template>
    </div>

    <mat-paginator class="ald-paginator"
                   *ngIf="jobsPage?.page as page"
                   [length]="page.totalElements"
                   [pageSize]="page.pageSize || pageSize"
                   [pageIndex]="pageNo"
                   [pageSizeOptions]="pageSizeOptions"
                   (page)="handlePage($event)"
                   aria-label="Select page">
    </mat-paginator>
  </div>

  <div class="ald-footer row">
    <p class="selection-summary" *ngIf="hasSelection()">{{ selectedCount() }} load(s) selected</p>
    <span class="spacer"></span>
    <button mat-stroked-button class="reset-btn" (click)="reset()">Reset</button>
    <button mat-flat-button color="primary" class="add-btn"
            [disabled]="!hasSelection()"
            (click)="add()">Add</button>
  </div>
</div>
